'use client';

import { MouseEvent, useCallback } from 'react';
import ProductCard, { ProductCardProps } from '@/components/ProductCard/ProductCard';
import { LIST_PAGE_IMAGE_SIZES } from '@/components/ResponsiveImage/sprdImageUtils';
import { tracker } from '@/utility/tracking/tracker';
import { Feature, SearchData } from '@/utility/tracking/types';

type MPProductCardProps = Omit<ProductCardProps, 'background' | 'link'> & {
  tracking: Feature<
    'product-list-click',
    'Product List Page' | 'Showroom Page',
    { search: SearchData }
  >;
  link: Omit<ProductCardProps['link'], 'onClick'>;
};

export const MPProductCard = ({ link, tracking, ...rest }: MPProductCardProps) => {
  const trackClick = useCallback(
    (_: MouseEvent, appearanceId: string) => {
      tracker.trackFeature({
        ...tracking,
        product: tracking.product ? { ...tracking.product, appearanceId } : undefined,
      });
    },
    [tracking]
  );

  return (
    <ProductCard
      background="gray"
      imageSizes={LIST_PAGE_IMAGE_SIZES}
      {...rest}
      link={{
        ...link,
        onClick: trackClick,
      }}
      optimizeImages
    />
  );
};
